import React from "react";
import { Radio } from "@mui/material";
import { useField, useForm, useFormState } from "react-final-form";
import { SettingRow } from "../SettingRow";
import { InformationalBannerDismissalStyle } from "../../../../../../common/service/server/dto/CMPSettingsDto";

const DISMISSAL_OPTIONS = [
  {
    value: InformationalBannerDismissalStyle.ACCEPT_BUTTON,
    label: "Accept Button",
    imagePath: "/assets/images/stay_compliant/privacy_center/consent/info_dismissal_accept.svg",
  },
  {
    value: InformationalBannerDismissalStyle.ACCEPT_AND_X_BUTTON,
    label: "Accept and X Button",
    imagePath:
      "/assets/images/stay_compliant/privacy_center/consent/info_dismissal_accept_and_x.svg",
  },
];

export const ConsentBannerUSDismissalRow = () => {
  const form = useForm();
  useField("informationalBannerDismissalStyle", { subscription: {} });
  const { values } = useFormState<{
    informationalBannerDismissalStyle?: InformationalBannerDismissalStyle;
  }>({ subscription: { values: true } });
  const selectedValue =
    values.informationalBannerDismissalStyle || InformationalBannerDismissalStyle.ACCEPT_BUTTON;
  const selectedBorderColor = "#5331c6";
  const unselectedBorderColor = "#918CA1";

  return (
    <SettingRow
      maxWidthChildren={true}
      title="Informational Banner Dismissal"
      helpText="Choose how users can dismiss the informational banner."
    >
      <div className="d-flex flex-wrap w-100" style={{ justifyContent: "space-between" }}>
        {DISMISSAL_OPTIONS.map((option) => {
          const isSelected = selectedValue === option.value;
          return (
            <div
              key={option.value}
              className="d-flex flex-column align-items-start"
              style={{ gap: "0.5rem", cursor: "pointer" }}
              onClick={() => form.change("informationalBannerDismissalStyle", option.value)}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  form.change("informationalBannerDismissalStyle", option.value);
                }
              }}
              role="button"
              tabIndex={0}
            >
              <div
                style={{
                  border: `2px solid ${isSelected ? selectedBorderColor : unselectedBorderColor}`,
                  borderRadius: "10px",
                  padding: "4px",
                  backgroundColor: "rgba(255, 255, 255, 0.6)",
                }}
              >
                <img src={option.imagePath} alt={option.label} style={{ width: "248px" }} />
              </div>
              <label className="d-flex align-items-center" style={{ gap: "0", cursor: "pointer" }}>
                <Radio
                  color="primary"
                  checked={isSelected}
                  name="informationalBannerDismissalStyle"
                  style={{ padding: 0, marginRight: "6px" }}
                  onChange={() => form.change("informationalBannerDismissalStyle", option.value)}
                />
                <span>{option.label}</span>
              </label>
            </div>
          );
        })}
      </div>
    </SettingRow>
  );
};
